import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import type {RootState} from "../../app/store";

export type AuthStatus = "ok" | "expired" | "loopBlocked";

interface SessionAuthState {
    status: AuthStatus;
}

const initialState: SessionAuthState = {
    status: "ok",
};

export const sessionAuthSlice = createSlice({
    name: "sessionAuth",
    initialState,
    reducers: {
        setAuthStatus: (state, action: PayloadAction<AuthStatus>) => {
            state.status = action.payload;
        },
    },
});

export const {setAuthStatus} = sessionAuthSlice.actions;

export const selectAuthStatus = (state: RootState) => state.sessionAuth.status;

export default sessionAuthSlice.reducer;
